import React, { useContext, useEffect, useRef, useState } from "react"
import { Box, ButtonGroup, Button, Grid2 as Grid, Typography, AppBar, Toolbar, Paper, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material"
import { MyLogout } from "../Logout"
import { Link, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom"
import { useEvent } from "../../context/eventContext";
import { get_Event_byID } from "../../FirebaseUtils/dbEvent";
import ElevationScroll from "../ElevationScroll";
import { CloudDone, Delete, Edit, Inventory, KeyboardArrowDown, Lock, ManageAccounts, PlaylistPlay, Settings } from "@mui/icons-material";
import useMediaQuery from '@mui/material/useMediaQuery';
import { EventDialog } from "../../modals/EventDialog";

const page_list = [
    { id: 'category', label: 'Categorie', link: 'category' },
    { id: 'cowlist', label: 'Soggetti', link: 'cowlist' },
    { id: 'propertylist', label: 'Aziende', link: 'propertylist' },
    { id: 'cowmanlist', label: 'Allevatori', link: 'cowmanlist' },
    { id: 'match', label: 'Gare', link: 'match' },
]
const admin_page_list = [
    { id: 'config', label: 'Config', link: '/config', icon: <Settings fontSize="small" /> },
    { id: 'users', label: 'utenti', link: '/users', icon: <ManageAccounts fontSize="small" /> },
    { id: 'eventlist', label: 'eventi', link: '/eventlist', icon: <PlaylistPlay fontSize="small" /> },
]


const AdminMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation()
    const navigate = useNavigate()
    const { hash, pathname, search } = location
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <>
            <Button
                fullWidth
                variant="outlined"
                color="warning"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                startIcon={<Settings />}
                endIcon={<KeyboardArrowDown />}
            >
                Config
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {admin_page_list.map((p, k) => (
                    <Link to={p.link} style={{ textDecoration: 'none' }}>
                        <MenuItem key={k} selected={pathname.endsWith(p.link)} onClick={handleClose}>
                            <ListItemIcon>
                                {p.icon}
                            </ListItemIcon>
                            <ListItemText>
                                {p.label}
                            </ListItemText>
                        </MenuItem>
                    </Link>
                ))
                }
            </Menu>
        </>
    );
}


const EventMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation()
    const { hash, pathname, search } = location
    const navigate = useNavigate()
    const { event_id } = useParams()
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    let currentPageLabel = ''
    const curpage = page_list.filter(p => pathname.endsWith(p.link))
    if (curpage.length > 0) {
        currentPageLabel = curpage[0].label

    }

    const clickMenu = (p) => {
        console.log("CLINKC", p, pathname, hash)
        navigate({ pathname: event_id + "/" + p })
        handleClose()

    }

    return (
        <>
            <Button
                fullWidth
                variant="outlined"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={<KeyboardArrowDown />}
            >
                gestione evento - {currentPageLabel}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {page_list.map((p, k) => (
                    <MenuItem key={k} selected={pathname.endsWith(p.link)} onClick={() => clickMenu(p.link)}>
                        <ListItemText>
                            {p.label}
                        </ListItemText>
                    </MenuItem>
                ))
                }
            </Menu>
        </>
    );
}

export const GlobalHeader = ({ admin }) => {
    const location = useLocation()
    const { hash, pathname, search } = location
    const dialogRef = useRef()
    const { event_id } = useParams()
    const { selEvent, setSelEvent } = useEvent()
    const matchCssSize = useMediaQuery('(min-width:1080px)');
    useEffect(() => {
        const initData = async () => {
            console.log("INIT DATA")
            if (event_id && selEvent?.id !== event_id) {
                const ev = await get_Event_byID(event_id)
                if (ev) {
                    setSelEvent(ev)
                }
            }
        }
        initData()

    }, [event_id])


    const reloadFn = (el) => {
        setSelEvent(el)
    }

    const handleEdit = () => {
        console.log("EDIT EVENT")
        dialogRef.current.onEdit(selEvent)
    }

    return (
        <>

            <Grid container alignItems={"center"} columnSpacing={1}>
                <EventDialog ref={dialogRef} reloadFn={reloadFn} />
                <Grid sx={{ textAlign: 'center' }} size="auto">
                    <img src="/logo-ANAFIBJ-600.png" width="40px" />
                    <Typography
                        sx={{ width: '100%', fontSize: '', fontWeight: 'bold', color: '#8fb5d7' }}
                    >
                        {matchCssSize &&
                            <>
                                ShowTimeANAFIBJ
                            </>}
                    </Typography>

                </Grid>
                <Grid sx={{ textAlign: 'center', }} size={3}>
                    {matchCssSize ?

                        <ButtonGroup fullWidth>
                            {
                                admin_page_list.map((p, k) => (
                                    <Button color="warning" variant={pathname.endsWith(p.link) ? 'contained' : 'outlined'} href={p.link} key={k} startIcon={p.icon}>{p.label}</Button>
                                ))
                            }
                        </ButtonGroup>
                        :
                        <AdminMenu />
                    }
                </Grid>
                <Grid size="grow">
                    {selEvent?.event_name &&
                        <>
                            <Grid size="grow" sx={{ textAlign: 'center', backgroundColor: '#8fb5d7', fontWeight: 'bold', fontSize: '1.2em' }} container justifyContent={"center"} alignItems={"center"}>
                                <Grid size="grow">
                                    {selEvent?.event_name}
                                </Grid>
                                <Grid size="auto">
                                    {selEvent?.is_public && <Tooltip arrow title="evento pubblico">
                                        <Button fullWidth href={`publiccatalog`} target="_blank" startIcon={<CloudDone style={{color: 'white'}} />}></Button>
                                    </Tooltip>}
                                </Grid>
                                <Grid size="auto">
                                    {selEvent?.lock_catalog && <Tooltip arrow title="catalogo bloccato"><Lock /></Tooltip>}

                                </Grid>
                                <Grid size="auto">
                                    {selEvent?.is_archived && <Tooltip arrow title="archiviato"><Inventory style={{color: 'red'}} /></Tooltip>}
                                </Grid>
                                <Grid size="auto">
                                    <Tooltip arrow title="modifica evento">
                                        <Button size="small" onClick={handleEdit}><Edit /></Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Grid sx={{ textAlign: "center" }}>
                                {matchCssSize ?
                                    <ButtonGroup fullWidth>
                                        {!admin &&
                                            page_list.map((p, k) => (
                                                <Button variant={pathname.endsWith(p.link) ? 'contained' : 'outlined'} href={p.link} key={k}>{p.label}</Button>
                                            ))}
                                    </ButtonGroup>
                                    :
                                    <EventMenu />
                                }

                            </Grid>
                        </>
                    }
                </Grid>
                <Grid size="auto" sx={{ textAlign: '' }}>
                    <MyLogout />
                </Grid>
            </Grid>
        </>
    )
}